import React from 'react';
import { SvgProps } from '../../../models/components/svg';

const CrossIcon: React.FC<SvgProps> = ({ className }) => (
    <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
    >
        <path
            d="M19.3301 5.35352L12.8086 11.875L19.3301 18.3965L18.623 19.1035L12.1016 12.582L5.58008 19.1035L4.87305 18.3965L11.3945 11.875L4.87305 5.35352L5.58008 4.64648L12.1016 11.168L18.623 4.64648L19.3301 5.35352Z"
            fill="#072648"
        />
    </svg>
);

export default CrossIcon;
